<ng-template [ngIf]="isRifiutandoPratica">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
      <form [formGroup]="rifiutaPraticaForm">
        <div class="grid formgrid p-fluid">
          <div class="field col-12">
            <label for="noteRifiutoPratica" class="font-small text-900 text-blue-900">Motivazione della bocciatura</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteRifiutoPratica" rows="5" [autoResize]="true" formControlName="noteRifiutoPratica" pInputTextarea></textarea>
              </span>
          </div>
        </div>
      </form>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isRifiutandoPratica || !rifiutaPraticaForm.valid"></p-button>
  </div>
    <p-toast />
    <p-confirmDialog /> 